import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

axios.defaults.withCredentials = true;

function RegisterPage({ setIsLoggedIn }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [role] = useState('racer');

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const roleToken = searchParams.get('roleToken');

  useEffect(() => {
    if (roleToken) {
      // The role will be determined by the token on the backend
    }
  }, [roleToken]);

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const url = roleToken ? `/api/users/register?roleToken=${roleToken}` : '/api/users/register';
      const postData = roleToken ? { username, password } : { username, password, role };
      const response = await axios.post(url, postData);
      setMessage(response.data.message);
      setIsLoggedIn(true);
    } catch (error) {
      if (error.response?.data === 'Director token has expired.') {
        setMessage('Your invitation has expired. Please contact us for a new link.');
      } else {
        setMessage(error.response?.data || 'Registration failed');
      }
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', backgroundColor: '#f0f2f5' }}>
      <div style={{ padding: '2rem', boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', transition: '0.3s', borderRadius: '5px', backgroundColor: 'white', width: '400px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Register</h2>
        <form onSubmit={handleRegister}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem' }}>Username (Email):</label>
            <input
              type="email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={{ width: '100%', padding: '0.5rem', borderRadius: '3px', border: '1px solid #ccc' }}
            />
          </div>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem' }}>Password:</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ width: '100%', padding: '0.5rem', borderRadius: '3px', border: '1px solid #ccc' }}
              />
              <InputAdornment position="end" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            </div>
          </div>
          <button type="submit" style={{ width: '100%', padding: '0.75rem', borderRadius: '3px', border: 'none', backgroundColor: '#007bff', color: 'white', cursor: 'pointer', marginTop: '1rem' }}>Register</button>
        </form>
        {message && <p style={{ marginTop: '1rem', textAlign: 'center', color: message.includes('failed') ? 'red' : 'green' }}>{message}</p>}
        <p style={{ marginTop: '1rem', textAlign: 'center' }}>
          Already have an account? <Link to="/login">Login here</Link>
        </p>
      </div>
    </div>
  );
}

export default RegisterPage;